import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

import img1 from "./assets/vet1.jpg";
import img2 from "./assets/vet2.jpg";

const images = [img1, img2];

const HeroSection = () => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative w-full h-[410px] md:h-[510px] overflow-hidden snap-section">

      <AnimatePresence mode="wait">
        <motion.img
          key={index}
          src={images[index]}
          alt="Veterinary LIMS"
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7 }}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </AnimatePresence>

      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 text-center">

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-[#FF7A00] font-semibold mb-4 uppercase tracking-wide"
        >
          Veterinary LIMS Platform
        </motion.p>

        {/* MAIN HEADING */}
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-2xl md:text-5xl font-bold text-white mb-4 max-w-[850px] leading-tight"
        >
          Smart Veterinary Diagnostics with{" "}
          <span className="text-[#FF7A00]">
            Advanced LIMS
          </span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-gray-200 mb-6 max-w-[650px] leading-relaxed"
        >
          Manage animal samples, streamline diagnostic workflows, and deliver accurate veterinary results with a powerful cloud-based Veterinary LIMS platform.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <Link to="/contact">
            <button className="bg-[#FF7A00] hover:bg-[#E56700] text-white px-8 py-3 rounded-lg font-semibold shadow-lg transition duration-300">
              Contact Us
            </button>
          </Link>
        </motion.div>

      </div>

      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
        {images.map((_, i) => (
          <div
            key={i}
            className={`h-2 w-6 rounded-full transition-all duration-300 ${
              i === index
                ? "bg-[#FF7A00] scale-110"
                : "bg-gray-400"
            }`}
          />
        ))}
      </div>

    </section>
  );
};

export default HeroSection;